import store from 'state/store/configureStore';
import _ from 'lodash';
import { ignoreOrgKeys } from '../constants/constants';

const resolveKeyWithOrgId = (key, orgId) => {
  let organizationId = orgId;
  if (!orgId && store) {
    const { organization } = store.getState();
    organizationId = _.get(organization, 'id', '');
  }
  return ignoreOrgKeys.includes(key) ? key : `${organizationId}_${key}`;
};

const BrowserStorageAccessor = (orgId = null) => ({
  local: {
    get: key => localStorage.getItem(resolveKeyWithOrgId(key, orgId)),
    set: (key, value) =>
      localStorage.setItem(resolveKeyWithOrgId(key, orgId), value),
    remove: key => localStorage.removeItem(resolveKeyWithOrgId(key, orgId))
  },
  session: {
    get: key => sessionStorage.getItem(resolveKeyWithOrgId(key, orgId)),
    set: (key, value) =>
      sessionStorage.setItem(resolveKeyWithOrgId(key, orgId), value),
    remove: key => sessionStorage.removeItem(resolveKeyWithOrgId(key, orgId))
  }
});

export default BrowserStorageAccessor;
